import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Seo from "@/components/Seo";
import { toast } from "sonner";
import { Shield } from "lucide-react";

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { saveSession } = useAuth();
  const [email, setEmail] = useState("admin@localdoctor.in");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/admin/login", { email, password });
      saveSession(data.token, data.user);
      toast.success("Welcome back, Admin.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mx-auto max-w-[460px] px-4 py-16">
      <Seo title="Admin login" canonicalPath="/admin/login" />
      <Link to="/" className="text-xs text-muted-foreground hover:text-foreground">← Back to home</Link>
      <form onSubmit={submit} className="mt-6 rounded-2xl border border-border p-7 shadow-sm grid gap-3" data-testid="admin-login-form">
        <span className="inline-flex h-12 w-12 rounded-xl bg-primary/10 text-primary items-center justify-center">
          <Shield size={22} />
        </span>
        <h1 className="font-display text-2xl font-bold">Admin console</h1>
        <p className="text-sm text-muted-foreground">Manage doctors, registrations and requests.</p>
        <label className="text-sm font-medium mt-2">Email
          <input type="email" required className="input-base mt-1" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
        </label>
        <label className="text-sm font-medium">Password
          <input type="password" required className="input-base mt-1" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
        </label>
        <button disabled={loading} className="btn-primary mt-2" data-testid="admin-login-submit">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </section>
  );
}
